import React, { Component } from "react";
import { Link } from "react-router-dom";

class Info extends Component {
  state = { clientOrder: null };
  componentDidMount() {
    var search = this.props.location.search.substring(1);

    var clientOrder = JSON.parse(
      '{"' +
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    );

    this.setState({ clientOrder });
  }
  render() {
    const { _ } = this.props;
    const fields = _.ClientForms.ClientOrder.Fields;
    const { clientOrder } = this.state;
    return (
      <div className="client-order">
        <h2 className="ml-3"> {_.ClientForms.ClientOrder.Title}</h2>
        <div className="ml-3 mb-5  d-flex report-sent-message">
          <i className="icon-omni-checkbox-true mr-2"></i>
          <h6>{_.ClientForms.ClientOrder.InfoMessage}</h6>
        </div>
        {clientOrder && (
          <div>
            <div className="d-flex flex-wrap ml-3 client-order-info">
              <div className="d-flex flex-wrap row report-details-1">
                {Object.keys(fields).map((field) => {
                  const val = decodeURIComponent(clientOrder[field]);
                  return (
                    <div className="col-4">
                      <h6>{fields[field]}</h6>
                      <p>{val ? val : "-"}</p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="d-flex mt-3 ml-3 green-button justify-content-start ">
              <Link to="/client-forms">
                <button
                  className="d-flex justify-content-center styled-button "
                  type="button"
                >
                  {_.ClientForms.ReturnToClientForms}
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Info;
